
import React from "react";
import { Helmet } from "react-helmet";

interface MetaComponentProps {
  title: string;
  desc?: string;
  keywords?: string;
}

const MetaComponent: React.FC<MetaComponentProps> = ({ title, desc, keywords }) => {
  return (
    <Helmet>
      <title>
        {title ||
          "Aptech Limited | Pioneer in the non-formal vocational training business"}
      </title>
      {desc && (
      <meta
        name="description"
        content={desc}
      />
    )}
    {keywords && (
      <meta
        name="keywords"
        content={keywords}
      />
    )}
    </Helmet>
  );
};

export default MetaComponent;
